import { parseTemplate } from 'url-template';
import { CaLabeling } from '~/Api/User/ProductGroup/CaLabeling/CaLabeling';
import { ErrorResponse } from '~/Api/User/ProductGroup/CaLabeling/ErrorResponse';
import { mapCaLabeling } from '~/Api/User/ProductGroup/CaLabeling/mapCaLabeling';
import { ProductUpdate } from '~/Api/User/ProductGroup/CaLabeling/ProductUpdate';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

export interface Result {
	caLabeling: CaLabeling;
}

export const updateCaLabeling = async (
	client: ApiClient,
	userId: string,
	groupId: string,
	referenceBasketVersion: string,
	products: ProductUpdate[]
): Promise<Result> => {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/ca-labeling');

	try {
		const request = await client.fetch(url.expand({ userId, groupId }), {
			body: JSON.stringify({
				products: products.map((product) => ({
					id: product.id,
					packageSizeForCalculation: product.packageSizeForCalculation,
				})),
				reference: {
					referenceBasketVersion,
				},
			}),
			method: 'POST',
		});
		const response = await request.json();
		return {
			caLabeling: mapCaLabeling(response.caLabeling),
		};
	} catch (error) {
		throw error instanceof ApiClientErrorResponse
			? new ErrorResponse(error.request, error.statusCode, error.errors)
			: error;
	}
};
